"use client";

import { useState } from "react";

import { cn } from "@/lib/utils";

/**
 * Avatar do cliente (EST-46): logo principal da marca quando houver (alt = nome do cliente); sem logo, ou se a imagem
 * quebrar, os `children` (iniciais sobre a cor de destaque). O `?v=` da URL muda quando a marca muda (cache).
 */
export function AvatarCliente({
  nome,
  logo,
  testid,
  className,
  classeComLogo,
  style,
  children,
}: {
  nome: string;
  logo?: string | null;
  testid: string;
  className: string;
  /** Classes extras quando o logo aparece (ex.: fundo claro no lugar da cor de destaque). */
  classeComLogo?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}) {
  const [quebrou, setQuebrou] = useState<string | null>(null);
  const comLogo = Boolean(logo) && quebrou !== logo;
  if (comLogo) {
    return (
      <span data-testid={testid} data-logo="sim" className={cn(className, classeComLogo)} style={{ ...style, backgroundColor: undefined }}>
        {/* <img> simples: a rota e autenticada pelo cookie da sessao (next/image buscaria sem ele). */}
        <img src={logo!} alt={nome} className="size-full object-contain" onError={() => setQuebrou(logo!)} />
      </span>
    );
  }
  return (
    <span data-testid={testid} aria-hidden className={className} style={style}>
      {children}
    </span>
  );
}
